<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="p13"></a>
<h1 class="chapter-title"><span><a href="#/toc#toc-chapter002">Two</a></span></h1>
<p class="noindent"><span class="dropcap">J</span>ust to be sure, just to make certain, just to be one hundred percent clear on the subject, Cook took the elevator back to
         the ground floor of the Hastings Building and reread the directory. The Pillow Agency occupied offices 1201 through 1209.
         Had he checked all of those? Maybe not, he told himself—although he had and knew it. He headed back to the elevator, glancing
         at the security guard at the front desk and wildly coveting his job.
     </p>
<p>“Steady, boy,” Cook told himself as he boarded the elevator. When it stopped he bolted out with determination.</p>
<p>The change that had occurred in his brief absence took his breath away. Doors that were formerly sealed shut now stood open.
         Attractive women passed in and out of them, glancing back meaningfully at him. Music—Rachmaninoff, wasn’t it?—wafted down
         the hall to him, seemingly borne by currents of perfume. The atmosphere was vibrant and industrious, with an undercurrent
         of lush sexuality. The Pillow Agency must have been on a break a few minutes earlier. Some break! He admired that kind of
         ability to swing into and out of action. Oh, he would fit right in here.
     </p>
<p>Fool that he was, the notion WRONG FLOOR! as an explanatory principle came to him late in the game, after he was already inside
         one of the offices—room 1101, to be <a id="p14"></a>exact. When the idea struck him he reddened and backed out quickly, after only about eight people had the chance to look up
         from their desks and wonder who he was and why he was so unemployed.
     </p>
<p>The elevator that had tricked him was gone. As he waited for another to take him to the twelfth floor, he wondered just how
         long this particular funhouse barrel-ride would last. He had been on many before—extended stretches of closely observed idiocies
         punctuated by near-criminal faux pas. It was the loner’s nightmare.
     </p>
<p>“Easy, boy. Easy,” he said aloud to himself—and, it turned out, to the woman behind his right shoulder, who had cruelly materialized
         from thin air. He grew suddenly angry, not with himself but with the linguistic law that licensed speakers to address themselves,
         but then revoked the privilege when others were present, even though these others committed self-speech, too. He tried to
         think of a way to mitigate his error, but what could he do? Tell the woman he was practicing talking to his dog?
     </p>
<p>An elevator arrived. Cook got in. The woman did not—spooked, no doubt. He managed to ride the one-floor distance alone without
         major incident. He exited and went to the right, back to the hall with rooms 1201 through 1209—still locked, each office as
         inaccessible as a dune-covered pyramid. At room 1209 he kept going, making two turns until he found himself entering an opulent
         waiting room near the elevators. He had come full circle.
     </p>
<p>Behind a counter sat a middle-aged woman dressed in a gray business suit and wearing round, rimless glasses. A large sign
         over the counter read <span class="small-caps">THE BUSINESS PEOPLE</span>.
     </p>
<p>“I’m looking for the Pillow Agency,” said Cook. “Are you connected with them at all?”</p>
<p>The woman looked at him without expression. She had been doing nothing behind the counter, and she continued to do nothing.
         Her glasses reflected pure white light in his face.
     </p>
<p>“They don’t seem to be here,” Cook went on.</p>
<p>“‘They’?” She gave the word a wavering, befuddled tone.</p>
<a id="p15"></a>
<p>“The Pillow people. Could they have left any kind of message for me?”</p>
<p>The woman let out a laugh, but without any change of expression. “I don’t know who you are.”</p>
<p>“Jeremy Cook.”</p>
<p>“No message,” she said without checking anywhere. She said it so quickly that it partly overlapped his name.</p>
<p>Cook sighed and looked somewhat pointlessly around the empty waiting room. “Could you take a message from me for them?” he
         asked.
     </p>
<p>“I <em>could</em>.”
     </p>
<p>“<em>Would</em> you?” Cook was so frustrated by the woman’s style that it took him a moment to see that she had a pen and pad ready for his
         dictation. This gave him a rush of mike-fright, and he had to collect his thoughts.
     </p>
<p>“Um, ‘To Mr. Pillow. From Jeremy Cook.’ Um, um, ‘Sorry I missed you.’ No, wait, um, ‘Sorry I missed you …’ Wait. Wait.”</p>
<p>The woman slowly raised her eyes from the pad to Cook, as if to say, “In the world of business, when men dictate, they <em>dictate</em>.”
     </p>
<p>“Um, okay, ‘To Mr. Pillow. From Jeremy Cook. Sorry I missed you. It’s four-thirty p.m., Friday.’”</p>
<p>“It’s four forty-five,” the woman said sharply.</p>
<p>“I know, but I was here promptly at four-thirty. That’s the whole point, you see.”</p>
<p>“You want me to backdate the memo?”</p>
<p>Cook couldn’t tell from her tone if this was a stroke of genius or a suicidal plan. But he said, “Yes. That’s it. Backdate
         it. Write ‘four-thirty.’”
     </p>
<p>She did so. “Anything else?”</p>
<p>“Um, ‘Will return …’ Are they open Saturday?”</p>
<p>“They are not.”</p>
<p>“Okay. ‘Will return Monday morning.’ No, no—make it ‘Monday a.m.’ That sounds better, doesn’t it? ‘Monday a.m.’?”</p>
<p>The woman ignored his question and folded the note. <a id="p16"></a>Cook’s eye fell on a stack of mail at the edge of the counter. On top of it was the latest issue of <em>Linguistic Inquiry</em>. He smiled—the journal was like an old friend in hostile territory, especially this quarter’s issue, because it would contain
         the results of the latest round of grant proposals to the Kartoffel Foundation. He was interested not for himself but for
         Paula, whose recent application he had supported, without her knowledge, with a warm letter of recommendation.
     </p>
<p>“May I look at this?” he asked, reaching for it.</p>
<p>“Mr. Pillow’s mail? You’re asking for permission to look at Mr. Pillow’s mail?”</p>
<p>“I meant the journal,” Cook said, lifting it from the stack and opening it to the back page.</p>
<p>“It came in the mail,” the woman said. “It is part of the mail. It <em>is</em> mail.”
     </p>
<p>“Just a peek,” he said, and Paula’s name leaped out at him—a winner. He grinned. Then he turned the journal over in his habitual
         way and idly checked the table of contents on the back cover. He let out a sharp yelp. The woman stared across the counter
         at him. “Look what they’ve done to me,” Cook said, pleading for sympathy. “Look.” He showed her the table of contents. He
         jabbed a finger at the title of the lead article: “Why Jeremy Cook’s Theory of Kickapoo Adverbs Is Preposterous.” But all
         he got from the woman was another flash of light from her eyeglasses. She went on with her business, attaching a piece of
         tape to the note she had written and carrying it around the counter and out of the waiting room.
     </p>
<p>Cook sighed and opened the journal to the article. A quick skim showed that it fulfilled the promise of its ugly title. The
         author was one F. F. Sweet—a name Cook didn’t recognize. It stood alone, without the customary institutional affiliation.
         (Denounced by a layman! Cook thought bitterly.) But one so informed about Kickapoo <em>had</em> to be an academic. He was probably an unemployed one. (Can’t land a job, Cook thought. Too much of a bastard!) F. F. Sweet’s
         only identification was “Washington, D.C.” (Good. Populous, <a id="p17"></a>strategically important. Likely to take a direct hit when the time came. Maybe soon! Cook hoped shortsightedly.)
     </p>
<p>Cook knew that the healthy response would have been to take pen in hand and show how this attack on his work was wrong—after
         reading it, of course. But there was a flaw in the plan: the article would make no sense to him. He had published his Kickapoo
         adverb theory some seven years earlier, while still in graduate school. Once he had conquered the subject he promptly forgot
         all about it.
     </p>
<p>But F. F. Sweet, it was clear, was Mr. Kickapoo Adverb himself. F. F. Sweet had a stranglehold on Kickapoo adverbs. F. F.
         Sweet spent holidays roaming rural roads and deer trails of the upper Midwest in search of garrulous Kickapoos squatting around
         their campfires, talking about time, place, manner, degree.
     </p>
<p>“This round goes to you, F. F Sweet,” Cook said aloud. Then he added a line from an old movie he’d seen late one night on
         TV, drunk. “Under other circumstances, I might have called you ‘friend.’” This was so outrageously false that it made him
         laugh and contributed to his next act.
     </p>
<p>He took the journal out into the hallway and pressed the elevator button. When the elevator doors opened he looked down at
         the floor. “<em>Good</em>,” he said. The space was just the right size. He bent down and wedged the bottom of the journal into the crack between the
         elevator and the hall floor. It stood tall there. He lifted his foot, and with one swift stomp he shot the journal through
         the crack, sending it careening into the elevator shaft like a damned soul hurled into hell.
     </p>
<p class="cotx">Cook returned to his car and studied his street map of St. Louis. Then he drove out of the parking garage and headed for 1-70
         again. But he would not go east—where he had been—but west, to a motel near the airport, where according to the P.S. in their
         letter the Pillow bastards had reserved a room for him.
     </p>
<a id="p18"></a>
<p>On the highway he calmed down and calculated how long he could live on his savings. It was impossible to spend money in southern
         Indiana, and as a result he had increased his net worth just like someone who knew what he was doing. His money was presently
         sitting in an account where a dinky return was offset by the fact that he never had to think about it. He had few expenses,
         drove an old car (a 1972 Honda Coupe), and traveled little (where was there to go?), and if he gave it a little fix-up, he
         could live rent-free in a summer cottage in northern Wisconsin owned by his sister in Chicago. He would set out for it the
         next morning. He had always wanted to live alone in a cottage for a while, just to see what kind of work he could do in complete
         isolation. He had a title for his first project, and a helluva title it was, too: “Kickapoo Adverbs: Response to F. F. Sweet.”
         All he needed was six months free and clear to relearn everything he had forgotten about the stinking subject.
     </p>
<p>A thought struck him—hard. The Pillow bastards’ mysterious absence might not have been so mysterious. Maybe they saw the F.
         F. Sweet article and decided to scrap the interview. Who wanted to interview a loser? He imagined a gang of them hurrying
         away from the office, sneaking out of the building to avoid him, maybe even passing him on the sidewalk and wondering to each
         other if that was the preposterous job candidate and giggling as they ducked into a bar.
     </p>
<p>With this image snuffing the last ember of his self-esteem, Cook took the airport exit, crossed the highway, and drove to
         the Centurion Inn.
     </p>
<p>The first thing to catch his eye in the lobby was a tall, thin, sad-faced man standing near the windows that looked out to
         the swimming pool. He had whirled around when Cook entered, and now advanced toward him, his eyebrows raised so high they
         sent wrinkles up his bald head to its very crown.
     </p>
<p>“Jeremy Cook?” he asked. “Jeremy Cook?”</p>
<p>“Yes?” Cook watched him approach. He wore a gray suit <a id="p19"></a>of overwhelming dullness. As if to make up for it, a gaily colored beach towel was wedged under one arm.
     </p>
<p>“Oh! Thank goodness!” the man said. “I’m Roy Pillow.” He thrust out his hand.</p>
<p>With profoundly mixed feelings, Cook took his hand. “I missed you at your office.”</p>
<p>Pillow frowned. This erased the wrinkles in the top half of his head and concentrated them just above his eyes. “My office?”</p>
<p>“I’ve just come from there. I left a note for you.”</p>
<p>“Why?”</p>
<p>“So that you would know I’d been there,” Cook said with a little laugh of impatience.</p>
<p>“Why didn’t you assume you would simply tell me, as you have just done?”</p>
<p>“Because I didn’t know I would <em>see</em> you.”
     </p>
<p>“Of course you did.”</p>
<p>“<em>What?</em>” Cook said, a little too loudly. He glanced to the front desk, where the clerk was watching them with undisguised interest.
     </p>
<p>“I arranged a meeting here,” said Pillow, casting his eyes around the lobby.</p>
<p>“If you did, you didn’t arrange it with me, and I’m the one who counts.”</p>
<p>Pillow smiled quizzically. “But I <em>did</em>. In my letter.”
     </p>
<p>Cook immediately produced the letter from his pocket. Pillow took it and read it, gently rocking back and forth from the waist
         up, as if pleasantly smitten by his own prose. He handed it back to Cook and said, “It’s there in black and white.”
     </p>
<p>“Are you kidding?” Cook was getting loud again, and he had to throttle down. “Listen. I’ll read it. ‘Dear Dr. Cook: Thank
         you for sending your dossier. I shall be delighted to meet you at four-thirty on Friday, June first. Please advise if this
         time is problematical. Sincerely, Roy Pillow, Director. P.S.: I have booked a room for you at the Centurion Inn on Williams
         Road, directly across from the airport.’” He looked <a id="p20"></a>up at Pillow, who of all things was beaming. “There is absolutely no basis for your interpretation of this letter,” Cook said
         sharply.
     </p>
<p>Pillow flinched and his smile disappeared. “Oh come now,” he said. “You’re not going to maintain—”</p>
<p>“If you wanted me to meet you here at four-thirty, you should have said so.”</p>
<p>Pillow shook his head. He seemed genuinely puzzled. “Why do you insist on pursuing this?”</p>
<p>“Because you’re <em>wrong</em>, that’s why. And you won’t admit it.”
     </p>
<p>“Would it help if I admitted it?” Before Cook could answer, Pillow looked at his watch and said, “Actually, I’m afraid we’ll
         have to table the subject. Is that all right with you?”
     </p>
<p>Pillow sounded so conciliatory that Cook felt all alone with his anger. “Sure,” he said. “Hell, I’m willing to drop it.”</p>
<p>“No, no. That wouldn’t be right. It’s just that I have a plane to catch”—Pillow paused, then quickly went on—“which is obviously
         why I booked you a room here in the first place, so far away from the office. Don’t you see?”
     </p>
<p>“That doesn’t prove a thing,” said Cook, suspicious again.</p>
<p>“I didn’t mean it to prove anything. I was just telling you that I have a plane to catch.”</p>
<p>“No you weren’t. You were sneaking in a final bit of support for what you think your letter says, even though it doesn’t support
         it at all and even though we agreed to drop the subject.”
     </p>
<p>Pillow put his hands out before him in the air, palms down. He looked like Jesus calming the waters. Cook focused his irritation
         on Pillow’s stupid beach towel, still firmly wedged under his arm.
     </p>
<p>“Let’s get you settled,” said Pillow.</p>
<p>“<em>Fine</em>,” said Cook. He turned to the clerk, who managed to greet them with formulaic friendliness, despite the fact <a id="p21"></a>that he must have considered both of them chuckleheads. Cook gave him his name. As the clerk typed it into the computer, Cook
         suddenly wondered about Pillow. Was he acting this way because he had seen that bit of nastiness by F. F. Sweet, or was he
         just permanently weird?
     </p>
<p>“I show no reservation under ‘Cook,’” the clerk said.</p>
<p>Pillow said, “Oh come now.”</p>
<p>“I’ll check again.” The clerk cleared the screen, retyped Cook’s name, and shook his head slowly.</p>
<p>“Try ‘Pillow’ then. Mrs. Pillow made the reservation, and she may have used our name.”</p>
<p>The clerk tried it. “No sir. Nothing under that name.”</p>
<p>“Oh come now,” said Pillow. “There must be some mistake.”</p>
<p>This was true, thought Cook. “Do you have any vacancies?” he asked the clerk.</p>
<p>“Yes sir.”</p>
<p>“Fine.” Cook turned to Pillow. “No problem.”</p>
<p>Pillow was frowning. “I don’t understand what can have happened.” He continued to brood and mutter while Cook registered.
         Cook got his room key, picked up his suitcase, and asked Pillow where he was going.
     </p>
<p>“Why, to your room. I intend to interview you.”</p>
<p>“I meant your flight,” Cook said. “You mentioned an airplane flight.”</p>
<p>“Oh. That. Seattle.” Pillow’s delivery was sharp. It was as if he were flying to Seattle to face charges of some kind. The
         subject was closed.
     </p>
<p>The two men went out into the central courtyard and began to circle around to Cook’s room, which was on the far side. Cook
         saw Pillow cast his eyes longingly at the pool. In light of Pillow’s beach towel, Cook suddenly felt obliged, as host in this
         context, to offer Pillow a swim, and he did.
     </p>
<p>“No time now,” Pillow said curtly.</p>
<p>Cook decided that the only way they would have a normal conversation would be if he acted as if he were interested in the
         job, though he no longer was.
     </p>
<a id="p22"></a>
<p>“I once heard a paper given by someone at the Pillow Agency,” Cook said. “It was on language death. It was—”</p>
<p>“Yes, yes,” said Pillow.</p>
<p>“Is he still with you? It was quite an interesting paper.”</p>
<p>“No,” said Pillow. “He pursued his subject to its logical end.”</p>
<p>“Oh.”</p>
<p>Evidently fearing that Cook hadn’t understood, Pillow said, rather loudly, “He’s <em>dead</em>.”
     </p>
<p>“Yes, I see,” Cook said quickly. “I’m sorry to hear that.” He stopped at the door of his room and took the key from his pocket.
         “Here we are.”
     </p>
<p>“He was a troublemaker,” said Pillow. “I made a mistake when I hired him. Since then I have had to be ve-ry, ve-ry careful.”</p>
<p>Cook nodded as he opened the door. His thought: “This guy is a nut for power.” Then he revised it: “This guy is a nut.”</p>
<p>Pillow walked in after Cook and sat down at the tiny table in front of the heavily draped window. “I don’t mean to rush you,”
         he said, rushing him.
     </p>
<p>“It’s all right,” said Cook, taking the other chair. “Let’s get started.”</p>
<p>Pillow folded his hands on the table and seemed to study them. Then he spoke: “In the life of the mind, criticism plays a
         vital role; feedback, be it positive or negative, should be encouraged, not discouraged.”
     </p>
<p>This threadbare truism, delivered in a form befitting it (one subjunctive, one passive, one tediously stress-marked antithesis),
         had an instant sedative effect on Cook, and he felt himself slipping fluidly out of his chair like a narcoleptic.
     </p>
<p>“How does a man climb a mountain?” Pillow asked, rousing Cook to semiconsciousness. Pillow kept his eyes on his hands. He
         made them rise, still folded, a few inches above the table. “He ascends and establishes a camp and stays the night. From there
         he ascends to another camp. Then to another. And another.” Pillow signified these <a id="p23"></a>ascents with equidistant elevations of his folded hands. They had reached eye level now, and Cook had to sit up in his chair
         to see Pillow’s face over them. “He is doing fine, our climber,” Pillow continued. “He is making good progress up the mountain.
         And then? A wise old mountain dweller comes to him and says, ‘You cannot climb the mountain this way. It is too dangerous.
         You must go a different way.’”
     </p>
<p>Cook found himself sadly disappointed by this news. He had gotten behind that mountain climber and was tickled by his progress.</p>
<p>“At first the climber disbelieves the old man.”</p>
<p>Yeah, thought Cook. Press on.</p>
<p>“He challenges the old man.”</p>
<p>Yeah. That’s the ticket. Throw the old fart off the mountain.</p>
<p>“He even sets out the next morning in defiance of the old man’s warning.”</p>
<p>Cook wondered what happened to the old man. Did he spend the night? Was there room in the tent for him? Was there enough tea
         and chocolate bars and stuff like that for him?
     </p>
<p>“But soon the climber sees that the old man spoke the truth. The route is fraught with … with danger.”</p>
<p>Cook sensed an illusion-threatening lack of actual mountaineering experience on the part of the narrator.</p>
<p>“Back he must go.” Pillow’s folded hands dropped a notch.</p>
<p>Maybe the old guy was waiting back at camp for him. Maybe he cooked the climber a nice hot lunch, just to show there were
         no hard feelings. Cook hoped so.
     </p>
<p>“Back. Back. Back.” Pillow’s folded hands descended until they lay at rest on the table. “But was the journey a waste?”</p>
<p>You tell me, sport.</p>
<p>“I say no. For the climb <em>had</em> to be attempted at that very spot. No other ascent could have been tried first. The climber <em>had</em> to fail.”
     </p>
<a id="p24"></a>
<p>Pillow smiled wanly and turned to Cook’s window, even though the drapes were drawn tight. Cook wondered if the interview was
         over now.
     </p>
<p>“Let’s say that our dramatis personae are scholars,” said Pillow, turning back to Cook and looking him in the eye. “The young
         climber was brave, but he was wrong. The old man had to point this out. In this particular area—on this <em>turf</em>, you might say—the old man was the expert, and the climber was in need of correction.”
     </p>
<p>Cook felt his stomach and intestines switch places. He imagined himself, young and impetuous, standing at his final mountain
         camp, gazing upward and contemplating his final assault. But look there! Look there! It’s F. F. Sweet, bustling toward him
         across the frozen waste, his rucksack stuffed with Kickapoo counterexamples and a shit-eating grin on his face.
     </p>
<p>“Why don’t you just come right out and say it?” Cook snapped.</p>
<p>“Very well,” said Pillow. “If you wish.” He took his beach towel from the bed, where he had set it, and began to unroll it
         on the table. He did it rather neatly, beginning a new roll at the end where he clutched the towel. Cook watched, fascinated,
         and waited for Pillow’s swimming suit and jockstrap to plop out before him—props in some new allegory, perhaps. There came
         the swimming suit and—no jockstrap? Didn’t he wear one? From inside the swimming suit Pillow took some printed sheets of flimsy
         onionskin. Pillow looked up at Cook. “How is your Icelandic?” he asked.
     </p>
<p>Cook had looked at the language maybe once in his life. “Rusty,” he said, wondering deeply what was going on.</p>
<p>“Here. Try this.”</p>
<p>Pillow held out the sheets. Cook took them and searched for his own name in the impenetrable text, under the assumption that
         his Kickapoo adverb theory was being denounced from all corners of the globe.
     </p>
<p>“Strong language, eh?” said Pillow.</p>
<a id="p25"></a>
<p>“I’m having some trouble,” Cook said, and at that moment he spied the name “Pillow.”</p>
<p>“Oh? It must be the dialect. But you get the essence.”</p>
<p>“Not really,” Cook said. “You’ll have to help me.”</p>
<p>Pillow smiled. “I know you’re just being modest, but I’ll play along. You’re quite a character. What we have here is a rebuttal
         of the very paper you mentioned earlier, the one on language death delivered by my former employee. He had it published shortly
         after he delivered it. Among the languages he listed as dead was the Icelandic dialect of Schnorrfark. This article takes
         issue with that claim, and rather convincingly—it is written <em>in</em> Schnorrfark by a living, viable speaker of it. There’s a whole townful of them, and I assure you that the Pillow Agency is
         not welcome there.”
     </p>
<p>Cook laughed heartily. Pillow seemed surprised at this, but then he joined in, his face and bald head instantly reddening.</p>
<p>“Now you know the worst about us,” Pillow said, still laughing. Then he became serious. It was a sudden plunge. “To tell you
         the truth, my feeling is that to be challenged in print is actually a distinction. Even if one is shown to be wrong, at least
         one has said something worth addressing.”
     </p>
<p>“Exactly,” said Cook. Evidently Pillow didn’t have a clue about Cook’s own recent experience in that line. “As a matter of
         fact—”
     </p>
<p>“Now that I’ve done my duty, so to speak, let me say that I was delighted to receive your application.”</p>
<p>“Really?”</p>
<p>“I’ve followed your work closely over the years, Jeremy. I must confess I barely knew the field of linguistics existed until
         I read <em>The Woof of Words</em>. Your book led me to others, but I’m still a newcomer. I just coordinate things for my people out in the field. I’m rather
         a linguistic ignoramus, to tell the truth. Please don’t expect me to know anything. Please don’t.”
     </p>
<p>“I promise I won’t,” Cook said in a voice so friendly he wished he heard himself use it more often.</p>
<a id="p26"></a>
<p>“As I said, your book led me to others, and in a sense it led to the Pillow Agency. You aren’t exactly a Founding Father,
         but I think of you as the John Locke behind the Founding Fathers.”
     </p>
<p>“My, my.”</p>
<p>“You can imagine my delight when you wrote to us. Now, whatever you were paid at the Wabash Institute, I’m willing to better
         it by twenty-five thousand.”
     </p>
<p>“Dollars?”</p>
<p>“Yes.”</p>
<p>Cook was pleased, even though he had no idea what this would total. He had always had a problem remembering his salary, what
         with the way it changed every year.
     </p>
<p>“Well?” said Pillow. “I’m eager to get this settled.”</p>
<p>A sudden cautionary impulse made Cook say, “May I sleep on it?”</p>
<p>A wave of disappointment crossed Pillow’s face. He was flustered, but he fought it and rallied. “Of course. Sleep. Sleep three
         nights, right here.” Pillow patted the bed like a jolly innkeeper. “I’ll pick up the tab for the room. If your answer is yes,
         come to work Monday morning. I don’t have to tell you where the office is.” Pillow chuckled somewhat normally. “If the answer
         is no, stay away. I will construe your absence as a polite decline of the offer, and no hard feelings. How does that sound?”
     </p>
<p>“It sounds fine. I don’t really know much about your agency. Do you have any sort of—”</p>
<p>“I’ll have something sent here for you to read.” Pillow looked at his watch and stood up. “I really must run now.”</p>
<p>“You know,” Cook said, rising with him, “in the spirit of confession, I should tell you about an article that just appeared
         about my work.”
     </p>
<p>“Oh?” Pillow said. “How nice.”</p>
<p>“Well … If what you said is true, yes, maybe it is nice.” Cook told all, surprised at how much relief he got from it. Almost
         all, anyway. He didn’t mention what he had done with Pillow’s copy of the journal.
     </p>
<a id="p27"></a>
<p>“<em>Linguistic Inquiry</em>, you say?” Pillow asked. He was a little less amused than Cook had hoped.
     </p>
<p>“Yes! That’s what’s such a killer about it—one of the top journals in the field.”</p>
<p>“Mmm,” said Pillow.</p>
<p>“Your Icelandic thing is peanuts compared to where <em>I</em> got blasted. Hell, you got off easy. Who cares what comes out of a culture that has only four or five surnames to pass around,
         right?” Cook laughed raucously.
     </p>
<p>“Yes, yes,” Pillow said. He seemed distracted as he slowly headed for the door. “A long article, you say?”</p>
<p>“Oh! Endless!”</p>
<p>“Mmm.” Pillow opened the door, then half turned toward Cook. Without looking at him, he said, “I’ve already offered you the
         job. I can’t very well withdraw the offer. Good Lord—<em>Linguistic Inquiry</em>. It’s a nightmare.” He pressed his lips together and inhaled sharply through his nose. “I’m stuck. That’s all there is to
         it—stuck.”
     </p>
<p>Pillow didn’t shake Cook’s hand. He simply turned away and left. He crossed the courtyard, muttering and shaking his head.</p>
<p>Cook stood in the doorway, frozen, holding himself in check, deliberately pausing at the threshold of remorse and despair.
         Then he plunged headlong into the abyss.
     </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter002.vue?a7deb7ce